import { Box, BoxProps, Text } from "@chakra-ui/react";

export function WarningBox({
  children,
  title,
  message,
  ...rest
}: {
  children?: React.ReactNode;
  title?: React.ReactNode;
  message?: React.ReactNode;
} & BoxProps) {
  return (
    <Box
      w="100%"
      bg="gray.100"
      border={"1px solid var(--chakra-colors-gray-200)"}
      p="4px"
      borderRadius="4px"
      {...rest}
    >
      <Text fontSize="12" whiteSpace="pre-wrap">
        {title ? (
          <Text as="span" fontWeight="bold">
            {title || "Aviso:"}
          </Text>
        ) : null}
        <br />
        {message || children}
      </Text>
    </Box>
  );
}
